import React from 'react';
import { View, ScrollView, Image, Linking } from 'react-native';
import { connect } from 'react-redux';
import queryString from "query-string";

import { addContentToUserProgress } from "../../../../redux/actions";

import Colors from "../../../../constants/Colors";
import {Button, SpinnerControl} from "../../../../components";
import {KnowledgeElementTitle} from "../KnowledgeElementTitle";
import {KnowledgeElementShortDescription} from "../KnowledgeElementShortDescription";
import {buttonContainerPropsStyle, buttonTextPropsStyle} from "../styles";
import get from "../../../../api/methods/get";
import {CONTENT_GET_SPECIFIC, JOURNEY_PATCH_PROGRESS} from "../../api/journeyEndpoints";
import NavBar from "../../../../components/NavBar";


class PodcastScreen extends React.Component {

    state = {
        isFetching: false,
        contentData: null
    }

    fetchOriginal = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {
            const values = queryString.parse(this.props.location.search);
            const contentId = values.contentId;
            let result = await get(CONTENT_GET_SPECIFIC('podcast', contentId));
            let json = await result.json();
            this.setState({ contentData: json.data });
        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

    handleLinkClick = async () => {

        try {
            await this.props.addContentToUserProgress('podcast', this.state.contentData.id);
        } catch (e) {
            console.log(e);
        }

        //TODO(Celso): Send log to increment activity usage!
        window.open(this.state.contentData.podcast)
    }

    componentDidMount() {
        this.fetchOriginal();
    }

    render() {
        return (
            <NavBar title={"Podcast"}>

                <SpinnerControl isFetching={this.state.isFetching} text={"Estamos carregando o conteúdo"} />

                {
                    this.state.contentData !== null &&
                        <View style={{ alignItems: 'center' }}>

                            <Image
                                source={require('../../timeline/icons/podcast.png')}
                                style={{ width: 64, height: 64, tintColor: Colors.fontColorOnBackground }}
                                resizeMode={'contain'}
                            />

                            <KnowledgeElementTitle title={this.state.contentData.title} />
                            <KnowledgeElementShortDescription shortDescription={this.state.contentData.shortDescription} />

                            <Button
                                text={"Acessar"}
                                onPress={this.handleLinkClick}
                                containerPropsStyle={buttonContainerPropsStyle}
                                textPropsStyle={buttonTextPropsStyle}
                            />

                        </View>
                }

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

export default connect(mapStateToProps, { addContentToUserProgress })(PodcastScreen);
